import { render, staticRenderFns } from "./RevenueMonthlyData.vue?vue&type=template&id=106fa48e&scoped=true"
import script from "./RevenueMonthlyData.vue?vue&type=script&lang=js"
export * from "./RevenueMonthlyData.vue?vue&type=script&lang=js"
import style0 from "./RevenueMonthlyData.vue?vue&type=style&index=0&id=106fa48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106fa48e",
  null
  
)

export default component.exports